/* import __COLOCATED_TEMPLATE__ from './pronunciation-type-option.hbs'; */
/* RESPONSIBLE TEAM: team-fin-voice */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { modifier } from 'ember-modifier';

interface ComponentAttrs {
  text: string;
  description?: string;
}

interface Signature {
  Args: {
    componentAttrs: ComponentAttrs;
  };
}

export default class PronunciationTypeOption extends Component<Signature> {
  @tracked isInDropdown = false;

  detectContext = modifier((element: HTMLElement) => {
    this.isInDropdown = !element.closest('button');
  });
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::VoicePlayground::PronunciationTypeOption': typeof PronunciationTypeOption;
    'ai-agent/voice-playground/pronunciation-type-option': typeof PronunciationTypeOption;
  }
}
